import {useLocation} from "react-router-dom";
import {Subject} from "rxjs";

const SET_BASE_URL= "SET_BASE_URL"
const SET_AUTH_TOKEN= "SET_AUTH_TOKEN"
const SET_AUTH_LOGIN= "SET_AUTH_LOGIN"
const SET_BASE_REGION = "SET_BASE_REGION"
const SET_LOGIN_STATE = "SET_LOGIN_STATE"
const SET_ADMIN_STATE = "SET_ADMIN_STATE"
const SET_TF_FILTER_STATE = "SET_TF_FILTER_STATE"
const SET_MAIN_MENU_ID = "SET_REDUX_STATE"
const SET_XFILTER_STATE = "SET_XFILTER_STATE"
const SET_ACTION_MESSAGE = "SET_ACTION_MESSAGE"
const SET_DOMAIN_PREFERENCE = "SET_DOMAIN_PREFERENCE"
const SET_USER_PREFERENCE = "SET_USER_PREFERENCE"
const SET_MOBILE_MODE = "SET_USER_PREFERENCE"
const SET_SHOW_STICKED_MENU = "SET_SHOW_STICKED_MENU"

const SET_SLIDER = "SET_SLIDER"
const SET_ORDER_DATA = "SET_ORDER_DATA"
const SET_ACCEPT_COOKIE = "SET_ACCEPT_COOKIE"
//const BASE_URL = "https://90.189.218.200:5001"


const  BASE_URL = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : "localhost"

//const  BASE_URL = "https://192.168.0.15:3001"
//         const BASE_URL = "https://sim-unlim.com:5000"






export interface IUserPreference
{
    showFooter:boolean
    showMainMenu:boolean
    showRegionChange:boolean
    showHeader:boolean
    showThirdMenu:boolean
    showSecondMenu:boolean
    showSlider:boolean
    showAcceptCookie:boolean
    [key:string]:any
}


export const defUserPreference:IUserPreference = {
    showMainMenu:true,
        showFooter: true,
        showHeader: true,
        showRegionChange: true,
        showSecondMenu: true,
        showSlider: true,
        showThirdMenu: true,
        showAcceptCookie: true
}


export interface IDomainPreference {
    stillLoad : boolean
    showMainFilter?: boolean
    showXFilter?:boolean
    skipCoupon?:boolean
    useBanner?:string
    slogan?:string
    mainPrice?:number
    mnpFollowMegafon?:string
    showReview?:boolean
    mainMenuClass?:string
    mainLogo?:string

    [key:string]:any
}

export interface ActionMessageInt
{
    message: string
    data?: any
}
export interface FilterSortItemInt
{
    title: string
    used:boolean
    id:number
}

export interface TariffFilterInt
{
    active:boolean
    appliedFilter:boolean
    filterOper:string[];
    filterType:number[];
    filterTether:number[];

    sort:FilterSortItemInt[]
    id?:number


}
interface BaseRegionInt
{
    macroRegionId?: number
    regionId?: number
    regionName?: string
    macroRegionName?: string
    makeSelectRegion?:boolean
    isChanged?:boolean

}

interface OrderDataInt
{
    regMode?:number
    useSelfReg?:boolean
    orderId?:string
    couponId?:string
    sessionId?:string
    regionData?:{
        regionId?:number
        macroRegionId?:number
        regionName?:string
        macroRegionName?:string
    }
    tarifData?:{
        tarifId?:string
        bundleId?:string
        operId?:string
        operName?:string
        price?: number
        newPrice?:number
        name?:string
        useSelfReg?:boolean
    }
    ctnData?:{
        ctn: string
        icc: string
        isSelected:boolean;
        operId?:string
        isMnp?:boolean
    },
    paymentData?:{
        paymentType:string
        amount:number
    }
    personalData?:{
        isPresent:boolean
        isCorrect:boolean
    }
    deliveryData?:{
        deliveryId:number
        delivery:string
        price: number
        postalCode:string
        id?:number
    }
    userData?:{
        login: string
        pass?: string
        existUser:boolean
    }
    mnpData?:{
        ctn:string
        macroRegionId:number
        regionId:number
        sameOper:boolean
        srcOper:string
        srcRegion?:string
    }
}

interface SliderInt
{
    sliderMode?:number
    dataCardItem?:any
    selectedTarif?:string
    hideItem?:boolean
    softCoupon?:string
}

interface XFilterInt
{
    val:string
    active : boolean
}
export interface ReduxStateInt
{
    baseUrl: string;
    authToken: string;
    baseRegion: BaseRegionInt;
    mobileMode: boolean;
    showStickedMenu: boolean

    isLogin: boolean;
    isAdmin: boolean;
    acceptCookie: boolean
    authLogin:string|null;
    tarifFilter: TariffFilterInt;
    xFilter: XFilterInt
    slider: SliderInt;
    orderData:OrderDataInt;
    activeMainMenuPad?:number;
    rxObserve: Subject<ActionMessageInt>
    prefDomain:IDomainPreference
    prefUser:IUserPreference

}
const authToken = localStorage.getItem("authToken")
const authLogin = localStorage.getItem("authLogin")


let lsTfFilter:any = null
let baseRegion:any = null

try {
    const lsFilterData = localStorage.getItem("tfFilter")
    if(lsFilterData ) lsTfFilter = JSON.parse(lsFilterData)

    const baseRegionData = localStorage.getItem("baseRegion")
    if(baseRegionData) baseRegion = JSON.parse(baseRegionData)
} catch (e) {}


const defaultState:ReduxStateInt =
    {
        baseUrl: BASE_URL,
        mobileMode: false,
        showStickedMenu: true,
        activeMainMenuPad:0,
        authToken:  authToken ? authToken : "",
        baseRegion: baseRegion ? baseRegion : {macroRegionId: 0, regionId: 0, regionName:"Не выбран",makeSelectRegion:false,isChanged:false},
        isLogin: localStorage.getItem("isLogin") !== undefined ? (localStorage.getItem("isLogin") === "1" ): false,
        isAdmin: localStorage.getItem("isAdmin") !== undefined ? (localStorage.getItem("isAdmin") === "1" ): false,
        authLogin: authLogin ,
        tarifFilter: lsTfFilter ? lsTfFilter : {active: false,appliedFilter:false,filterOper:[],filterType:[],filterTether:[],id:-1,sort:""},
        slider: {sliderMode: 0,dataCardItem:{},selectedTarif:"",hideItem: true},
        orderData: {},
        acceptCookie: localStorage.getItem("acceptCookie")!==undefined ? (localStorage.getItem("acceptCookie") === "1" ): false,
        xFilter:{
            val: "",
            active: false
        },
        rxObserve: new Subject<ActionMessageInt>(),
        prefDomain:{
            stillLoad: true,
            showMainFilter: true,
            showXFilter: true,
            skipCoupon: false,
            slogan: "Выгодные тарифы, которых не найти у оператора",

            useBanner: "white_2.jpg",
            showReview: true,
  //          mainMenuClass:"beeMenuItem",
    //        mainLogo:"beeLogo",
        },
        prefUser: defUserPreference
    }

export default function globalReducer(state= defaultState,action:any ):ReduxStateInt
{
    switch (action.type)
    {
        case SET_ACTION_MESSAGE:
            state?.rxObserve?.next(action?.payload)
            return state
        case SET_XFILTER_STATE:
            return {...state, xFilter: action.payload}
        case SET_MAIN_MENU_ID:
            return {...state, activeMainMenuPad: action.payload}
        case SET_MOBILE_MODE:
            return {...state, mobileMode: action.payload}
        case SET_SHOW_STICKED_MENU:
            return {...state, showStickedMenu: action.payload}
        case SET_BASE_URL:
            return {...state, baseUrl: action.payload}
        case SET_BASE_REGION:

            localStorage.setItem('baseRegion',JSON.stringify(action.payload));
            return {...state, baseRegion: {...state.baseRegion, ...action.payload}}

        case SET_SLIDER:
            return {...state, slider: {...state.slider, ...action.payload}}
        case SET_DOMAIN_PREFERENCE:
            //console.log("set", action.payload)
            return {...state, prefDomain:action.payload}

        case SET_USER_PREFERENCE:
            //console.log("set", action.payload)
            return {...state, prefUser:action.payload}

        case SET_ORDER_DATA:
            return {...state, orderData: {...state.orderData, ...action.payload}}

        case SET_LOGIN_STATE:
            if(action.payload) localStorage.setItem("isLogin","1")
            else localStorage.setItem("isLogin","0")
            return {...state, isLogin: action.payload}
        case SET_ADMIN_STATE:
            if(action.payload) localStorage.setItem("isAdmin","1")
            else localStorage.setItem("isAdmin","0")
            return {...state, isAdmin: action.payload}

        case SET_AUTH_TOKEN:
            localStorage.setItem('authToken',action.payload);
            return {...state, authToken: action.payload}

        case SET_AUTH_LOGIN:
            localStorage.setItem('authLogin',action.payload);
            return {...state, authLogin: action.payload}

        case SET_TF_FILTER_STATE:
            localStorage.setItem('tfFilter',JSON.stringify(action.payload));
            return {...state, tarifFilter: action.payload}
        case SET_ACCEPT_COOKIE:
            if(action.payload) localStorage.setItem("acceptCookie","1")
            else localStorage.setItem("acceptCookie","0")

            return {...state, acceptCookie: action.payload}




        default: return state;
    }
}
export const setBaseUrl = (data:string) => ({type:SET_BASE_URL,payload: data});
export const setMainMenuId = (data:number) => ({type:SET_MAIN_MENU_ID,payload: data});

export const setLoginState = (data: boolean ) => ({type:SET_LOGIN_STATE,payload: data});
export const setAdminState = (data: boolean ) => ({type:SET_ADMIN_STATE,payload: data});
export const setAcceptCookie = (data: boolean ) => ({type:SET_ACCEPT_COOKIE,payload: data});

export const setAuthToken = (bearer:string) => ({type: SET_AUTH_TOKEN,payload: bearer});
export const setXFilterValue = (val:XFilterInt) => ({type: SET_XFILTER_STATE,payload: val});
export const setAuthLogin = (login:string|null) => ({type: SET_AUTH_LOGIN,payload: login});
export const setTfFilter = (filter:TariffFilterInt) => ({type: SET_TF_FILTER_STATE,payload:filter});
export const setBaseRegion = (data:BaseRegionInt) => ({type: SET_BASE_REGION,payload: data});
export const setSlider = (data:SliderInt) => ({type: SET_SLIDER,payload: data});

export const setOrderData = (data:OrderDataInt) => ({type: SET_ORDER_DATA,payload: data});
export const sendActionMessage  = (data:string) => ({type: SET_ACTION_MESSAGE,payload: data});


export const setMobileMode  = (data:boolean) => ({type: SET_MOBILE_MODE,payload: data});
export const setShowStickedMenu  = (data:boolean) => ({type: SET_SHOW_STICKED_MENU,payload: data});

export const setDomainPreference  = (data:IDomainPreference) => ({type: SET_DOMAIN_PREFERENCE,payload: data});
export const setUserPreference  = (data:IUserPreference) => ({type: SET_USER_PREFERENCE,payload: data});

